import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid, TextField,
  Typography
} from '@material-ui/core';
import React from 'react';
import { observer } from 'mobx-react';
import { Title } from 'chart.js';

const AmazonTab = observer(({ mainBookFormStore }) => {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h1">Amazon</Typography>
            <FormGroup>
              <FormControlLabel control={<Checkbox
                checked={!mainBookFormStore.showAmazonLinks}
                onChange={e => mainBookFormStore.setShowAmazonLinks(!e.target.checked)} />}
                                label='Livro não disponível para compra' />
            </FormGroup>
          </Grid>
        </Grid>
        {mainBookFormStore.showAmazonLinks && <Box>
          <br />
          <hr />
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='h3' gutterBottom>Link para monitoria</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='URL Amazon'
                         onChange={(e) => mainBookFormStore.setAmazonLinkData('monitoring_url', e.target.value)}
                         value={mainBookFormStore.formData.links_amazon?.monitoring_url}
                         error={mainBookFormStore.errors.linksAmazonFields?.monitoring_url} fullWidth />
              <br /><br /><br />
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h3' gutterBottom>Livro físico</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='ISBN'
                         onChange={(e) => {
                           if (e.target.value.length > 14) {
                             e.target.value = e.target.value.slice(0, 14);
                             return;
                           }
                           mainBookFormStore.setAmazonLinkData('isbn', e.target.value)}
                         }
                         value={mainBookFormStore.formData.links_amazon?.isbn}
                         error={mainBookFormStore.errors.linksAmazonFields?.isbn} />
            </Grid>
            <Grid item xs={12}>
              <TextField label='URL Seeds'
                         onChange={(e) => mainBookFormStore.setAmazonLinkData('physical_url', e.target.value)}
                         value={mainBookFormStore.formData.links_amazon?.physical_url}
                         error={mainBookFormStore.errors.linksAmazonFields?.physical_url} fullWidth />
              <br /><br /><br />
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h3' gutterBottom>Livro digital (Kindle)</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='ASIN'
                         onChange={(e) => {
                           if (e.target.value.length > 10) {
                             e.target.value = e.target.value.slice(0, 10);
                             return;
                           }
                           mainBookFormStore.setAmazonLinkData('asin', e.target.value)}
                         }
                         value={mainBookFormStore.formData.links_amazon?.asin}
                         error={mainBookFormStore.errors.linksAmazonFields?.asin} />
            </Grid>
            <Grid item xs={12}>
              <TextField label='URL Seeds'
                         onChange={(e) => mainBookFormStore.setAmazonLinkData('digital_url', e.target.value)}
                         value={mainBookFormStore.formData.links_amazon?.digital_url}
                         error={mainBookFormStore.errors.linksAmazonFields?.digital_url} fullWidth />
              <br /><br /><br />
            </Grid>
          </Grid>
        </Box>}
      </CardContent>
    </Card>
  );
});

export default AmazonTab;
